"use client";

import { Bar, BarChart, Cell, XAxis, YAxis, ResponsiveContainer } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent, ChartConfig } from '@/components/ui/chart';
import type { AllStatusData } from '@/lib/types';

interface StatusChartProps {
  data: AllStatusData;
}

const chartConfig = {
  count: {
    label: "Count",
  },
  ready: { label: "Ready", color: "hsl(var(--primary))" },
  completed: { label: "Completed", color: "hsl(var(--chart-2))" },
  open: { label: "Open", color: "hsl(var(--destructive))" },
  customer: { label: "Customer", color: "hsl(var(--chart-4))" },
  item: { label: "Item", color: "hsl(var(--chart-5))" },
  mismatch: { label: "Mismatch", color: "hsl(var(--chart-1))" },
  issue: { label: "Issue", color: "hsl(var(--accent))" },
  unite_mismatch: { label: "Unite Mismatch", color: "hsl(var(--destructive))" },
} satisfies ChartConfig;


export default function StatusChart({ data }: StatusChartProps) {
  const chartData = [
    { status: 'ready', count: data.ready?.count || 0 },
    { status: 'completed', count: data.completed?.count || 0 },
    { status: 'open', count: data.open?.count || 0 },
    { status: 'customer', count: data.customer?.count || 0 },
    { status: 'item', count: data.item?.count || 0 },
    { status: 'mismatch', count: data.mismatch?.count || 0 },
    { status: 'issue', count: data.issue?.count || 0 },
    { status: 'unite_mismatch', count: data.unite_mismatch?.count || 0 },
  ];

  return (
    <div className="h-[350px] w-full">
        <ChartContainer config={chartConfig} className="w-full h-full">
            <ResponsiveContainer width="100%" height="100%">
                <BarChart accessibilityLayer data={chartData} layout="vertical" margin={{ left: 20, right: 10, top: 10, bottom: 10 }}>
                <YAxis
                    dataKey="status"
                    type="category"
                    tickLine={false}
                    tickMargin={5}
                    axisLine={false}
                    width={110}
                    tickFormatter={(value) => chartConfig[value as keyof typeof chartConfig]?.label}
                />
                <XAxis dataKey="count" type="number" hide />
                <ChartTooltip
                    cursor={false}
                    content={<ChartTooltipContent indicator="dot" />}
                />
                <Bar dataKey="count" layout="vertical" radius={5}>
                    {chartData.map((entry) => (
                    <Cell key={`cell-${entry.status}`} fill={chartConfig[entry.status as keyof typeof chartConfig].color} />
                    ))}
                </Bar>
                </BarChart>
            </ResponsiveContainer>
        </ChartContainer>
    </div>
  );
}
